module.exports = __webpack_public_path__ + "img/morningsun.54e0bdc9.jpg";